import {useAppSelector} from "../../../redux/hooks";
import {deviceStore} from "../../../redux/device/deviceStore";
import {keyboardHelpLinks} from "../../../config/config";

export interface IKeyboardConnectionHelpProps {
  device: string;
  supportLink: string;
}

export const useKeyboardConnectionHelp = (): IKeyboardConnectionHelpProps => {
  const isIPad = useAppSelector(deviceStore.getDeviceIsIPad);
  const isIPhone = useAppSelector(deviceStore.getDeviceIsIPhone);
  const isAndroid = useAppSelector(deviceStore.getDeviceOsIsAndroid);
  const isMacDesktop = useAppSelector(deviceStore.getDeviceIsMacDesktop);
  const isWindowsDesktop = useAppSelector(deviceStore.getDeviceIsWindowsDesktop);

  if (isIPad) {
    return {
      device: 'iPad',
      supportLink: keyboardHelpLinks.ipadAndIPhone,
    }
  }

  if (isIPhone) {
    return {
      device: 'iPhone',
      supportLink: keyboardHelpLinks.ipadAndIPhone,
    }
  }

  if (isAndroid) {
    return {
      device: 'Android device',
      supportLink: keyboardHelpLinks.android,
    }
  }

  if (isMacDesktop || isWindowsDesktop) {
    return {
      device: 'computer',
      supportLink: keyboardHelpLinks.computer,
    }
  }

  return {
    device: 'device',
    supportLink: keyboardHelpLinks.unknown,
  }
}
